import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import type { RootState } from "types/state";
import ProfileInfoCard from "./ProfileInfoCard";

interface CompanyInfo {
  id?: string;
  name?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  phoneExt?: string;
  fax?: string;
}

interface OwnProps {
  company?: CompanyInfo;
  setTab?: (...args: unknown[]) => void;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  // state.employer.company is Record<string, unknown> until the reducer
  // converts — narrow to the locally-used shape at the boundary.
  const company = state.employer.company as CompanyInfo;

  return { company, ownProps };
};

const mapDispatchToProps = { push };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<OwnProps> & PropsFromRedux;

class ProfileInfo extends React.Component<Props> {
  _isMounted = false;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div
        className="tab-pane"
        id="account"
        role="tabpanel"
        aria-labelledby="account_tab"
      >
        <ProfileInfoCard companyInfo={this.props.company} />
      </div>
    );
  }
}

export default connector(withApollo<Props>(ProfileInfo));
